if (!customElements.get('product-videos')) {
  class ProductVideos extends HTMLElement {
    connectedCallback() {
      this.lightbox = this.querySelector('[data-lightbox]');
      this.iframe = this.querySelector('[data-lightbox-iframe]');
      this.titleEl = this.querySelector('[data-lightbox-title]');
      this.swiperInstance = null;
      this.autoplayResumeTimer = null;

      this.bindThumbnails();
      this.bindLightbox();
      this.initSwiper();
    }

    // ---- Thumbnails ----

    bindThumbnails() {
      this.querySelectorAll('[data-video-id]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          this.openLightbox(btn.dataset.videoId, btn.dataset.videoTitle);
        }.bind(this));
      }.bind(this));
    }

    // ---- Lightbox ----

    bindLightbox() {
      this.querySelectorAll('[data-lightbox-close]').forEach(function(el) {
        el.addEventListener('click', function() {
          this.closeLightbox();
        }.bind(this));
      }.bind(this));

      document.addEventListener('keyup', function(e) {
        if (e.code === 'Escape' && this.lightbox && this.lightbox.classList.contains('active')) {
          this.closeLightbox();
        }
      }.bind(this));
    }

    openLightbox(videoId, title) {
      if (!this.lightbox || !this.iframe) return;

      this.iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
      if (this.titleEl) this.titleEl.textContent = title || '';

      this.lightbox.hidden = false;
      // Force reflow before adding active class for transition
      this.lightbox.offsetHeight;
      this.lightbox.classList.add('active');
      document.body.classList.add('overflow-hidden');

      // Pause Swiper autoplay
      this.pauseAutoplay();
    }

    closeLightbox() {
      if (!this.lightbox) return;

      this.lightbox.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

      // Stop video
      if (this.iframe) this.iframe.src = '';

      // Hide after transition
      setTimeout(function() {
        this.lightbox.hidden = true;
      }.bind(this), 300);

      // Resume autoplay after delay
      this.scheduleAutoplayResume();
    }

    // ---- Swiper integration ----

    initSwiper() {
      // The testimonials.js init will handle the Swiper instance via the
      // .testimonials-section class and data attributes. We just need to
      // hook into it after it initializes to add our pause/resume behavior.

      // Wait for Swiper to be initialized by testimonials.js
      var self = this;
      var checkInterval = setInterval(function() {
        var swiperEl = self.querySelector('.swiper');
        if (swiperEl && swiperEl.swiper) {
          self.swiperInstance = swiperEl.swiper;
          self.bindSwiperEvents();
          clearInterval(checkInterval);
        }
      }, 200);

      // Stop checking after 5 seconds
      setTimeout(function() {
        clearInterval(checkInterval);
      }, 5000);
    }

    bindSwiperEvents() {
      if (!this.swiperInstance) return;

      var self = this;

      // Pause autoplay on manual interaction, resume after 8s
      this.swiperInstance.on('sliderMove', function() {
        self.pauseAutoplay();
        self.scheduleAutoplayResume();
      });

      // Arrow clicks
      var arrows = this.querySelectorAll('.swiper-button');
      arrows.forEach(function(arrow) {
        arrow.addEventListener('click', function() {
          self.pauseAutoplay();
          self.scheduleAutoplayResume();
        });
      });
    }

    pauseAutoplay() {
      if (this.swiperInstance && this.swiperInstance.autoplay) {
        this.swiperInstance.autoplay.stop();
      }
      if (this.autoplayResumeTimer) {
        clearTimeout(this.autoplayResumeTimer);
        this.autoplayResumeTimer = null;
      }
    }

    scheduleAutoplayResume() {
      if (this.autoplayResumeTimer) {
        clearTimeout(this.autoplayResumeTimer);
      }
      var self = this;
      this.autoplayResumeTimer = setTimeout(function() {
        if (self.swiperInstance && self.swiperInstance.autoplay && !self.lightbox.classList.contains('active')) {
          self.swiperInstance.autoplay.start();
        }
      }, 8000);
    }
  }

  customElements.define('product-videos', ProductVideos);
}
